var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIconSimple({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71218 0.64109L6.28787 0.641089L6.28787 6.28784L0.641113 6.28784V7.71216L6.28787 7.71216L6.28787 13.3589L7.71218 13.3589L7.71218 7.71216L13.3589 7.71216V6.28784L7.71218 6.28784L7.71218 0.64109Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconSimple);
export default __webpack_public_path__ + "static/media/plus-icon-simple.964ac44ce624427c42ffc26a0f60b142.svg";
export { ForwardRef as ReactComponent };